import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgUploadFolder = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsx("g", {
		clipPath: "url(#uploadFolderClip)",
		children: /* @__PURE__ */ _jsx("path", {
			d: "M19 3H12.472C12.318 3 12.162 2.964 12.025 2.895L8.872 1.319C8.457 1.111 7.993 1.001 7.528 1.001H5C2.243 1 -3.57628e-07 3.243 -3.57628e-07 6V18C-3.57628e-07 20.757 2.243 23 5 23H8C8.552 23 9 22.553 9 22C9 21.447 8.552 21 8 21H5C3.346 21 2 19.654 2 18V9H22V18C22 19.654 20.654 21 19 21H16C15.448 21 15 21.447 15 22C15 22.553 15.448 23 16 23H19C21.757 23 24 20.757 24 18V8C24 5.243 21.757 3 19 3ZM2 6C2 4.346 3.346 3 5 3H7.528C7.682 3 7.836 3.036 7.975 3.106L11.131 4.683C11.546 4.89 12.009 4.999 12.472 4.999H19C20.302 4.999 21.402 5.838 21.816 6.999H2V6ZM14.293 15.896L13 14.603V22C13 22.553 12.552 23 12 23C11.448 23 11 22.553 11 22V14.603L9.707 15.896C9.512 16.091 9.256 16.189 9 16.189C8.744 16.189 8.488 16.091 8.293 15.896C7.902 15.505 7.902 14.873 8.293 14.482L9.906 12.869C11.024 11.75 12.975 11.75 14.094 12.869L15.707 14.482C16.098 14.873 16.098 15.505 15.707 15.896C15.316 16.287 14.684 16.287 14.293 15.896Z",
			fill: "currentColor"
		})
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "uploadFolderClip",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgUploadFolder;
